import * as React from "react"
import { cn } from "../../lib/utils"

const Button = React.forwardRef(({ className, children, ...props }, ref) => {
  return (
    <button
      className={cn(
        "active:translate-x-boxShadowX active:translate-y-boxShadowY transform",
        "rounded-base border-2 border-border dark:border-darkBorder bg-main px-4 py-2 text-sm font-base shadow-light dark:shadow-dark",
        "transition-all hover:translate-x-boxShadowX hover:translate-y-boxShadowY hover:shadow-none dark:hover:shadow-none",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      ref={ref}
      {...props}
    >
      {children}
    </button>
  )
})
Button.displayName = "Button"

export { Button }
